import Lottie from 'lottie-react';

import type { IAnimation } from './Animation.helpers';

const Animation = ({ animationData, height, width, autoPlay = true, loop = true }: IAnimation) => (
	<Lottie
		animationData={animationData}
		loop={loop}
		autoPlay={autoPlay}
		style={{ width, height }}
	/>
);

export default Animation;
